module.exports = __webpack_public_path__ + "img/figensoft-logo.c0c10111.svg";